import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import { getFinanceBackMoneyById } from '@/api/financial-center'
import { menuBtn } from '@/utils/menu_level2_button'
import * as math from 'mathjs'

@Component({})
export default class BackMoneyStudentInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    status = ''
    isUpdatedData = '0'
    activities = []
    fileList = []
    loading = false
    get orderAllPrice() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber( Number(item.price))))
        })
        return num
    }

    get needBackMoney() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.needBackMoney))))
        })
        return num
    }

    get thisBackMoney() {
        let num = 0
        this.backMoneyInfo.financeBackMoneyDetailList.forEach(item => {
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.thisTimePrice))))
        })
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo.financeBackMoneyProofList.map(item => item.url)
    }

    menuBtn = menuBtn

    created() {
        this.backMoneyId = Number(this.$route.query.id)
        this.getFinanceBackMoneyById()
        if(this.$route.query.status) this.status = this.$route.query.status as string
        if(this.$route.query.isUpdatedData) this.isUpdatedData = this.$route.query.isUpdatedData as string
    }

    formatDate = formatDate
    async getFinanceBackMoneyById() {
        this.loading = true
        await getFinanceBackMoneyById({ id: this.backMoneyId, isUpdatedData: this.isUpdatedData }).then((data: any)=>{
            this.backMoneyInfo = data.financeBackMoney
            //    审批流程
            this.activities = data.financeBackMoney.messageReviewList
            this.fileList = this.backMoneyInfo.financeBackMoneyProofList
            this.loading = false
        }).catch(err=>{
            this.loading = false
        })

    }

    editBackMoney() {
        if(this.status === '审批中') {
            this.$message.error('审批中，不可编辑')
            return
        }
        this.$router.push({
            path: 'newBackMoneyStudent',
            query: {
                backMoneyId: String(this.backMoneyId),
                status: this.status,
                isUpdatedData: this.isUpdatedData
            }
        })
    }
}
